import React from "react";

const HourRepeatSchedule = ({
  scheduleInfo,
  openDatePicker,
  setOpenDatePicker,
  setScheduleInfo,
  formatEndDate,
  Label,
  GMSBorderlessButton,
  DatePicker1,
}) => {
  const handleEndDateClick = () => {
    setOpenDatePicker((prev) => !prev);
  };

  const handleEndDateSelection = (date) => {
    const formattedEndDate = formatEndDate(date);
    setScheduleInfo((prevScheduleInfo) => ({
      ...prevScheduleInfo,
      endDate: formattedEndDate,
    }));
    setOpenDatePicker((prev) => !prev);
  };

  const handleClearEndDate = () => {
    setOpenDatePicker((prev) => !prev);
    setScheduleInfo((prevScheduleInfo) => ({
      ...prevScheduleInfo,
      endDate: "",
    }));
  };

  return (
    <div className="mt-2">
      <div className="d-flex align-items-center">
        <Label
          message="Occurs every hour until."
          fontSize="0.8125"
          color="#7B7D80"
        />
        &nbsp; &nbsp; &nbsp;
        {!openDatePicker && scheduleInfo.endDate === "" && (
          <GMSBorderlessButton
            name={
              scheduleInfo.endDate === ""
                ? "Choose end date"
                : scheduleInfo.endDate
            }
            disabled={scheduleInfo.endDate !== ""}
            onClick={handleEndDateClick}
          />
        )}
        {scheduleInfo.endDate !== "" && (
          <Label
            message={scheduleInfo.endDate}
            color="#091CAA"
            fontWeight="400"
            fontSize="0.875"
          />
        )}
        &nbsp;&nbsp;&nbsp;
        {openDatePicker && (
          <DatePicker1
            className="border-0 w-25"
            selected={scheduleInfo.endDate}
            disabled={true}
            minDate={new Date()}
            onChange={handleEndDateSelection}
            open={openDatePicker}
          />
        )}
        {scheduleInfo.endDate !== "" && (
          <GMSBorderlessButton
            name="Select end date"
            onClick={handleClearEndDate}
          />
        )}
      </div>
    </div>
  );
};

export default HourRepeatSchedule;
